export default __webpack_public_path__ + "static/media/ico-download.b4cb823e.svg";